import React from "react";

export interface IconData {
  url?: string;
  svg?: string;
}

export interface IconProps {
  icon?: IconData;
  alt?: string;
  className?: string;
}

const Icon: React.FC<IconProps> = ({ icon, alt = "Icon", className }) => {
  // Priority: icon.svg -> icon.url -> broken image
  if (icon?.svg) {
    return (
      <div
        className={className}
        dangerouslySetInnerHTML={{ __html: icon.svg }}
      />
    );
  }

  return <img src={icon?.url || ""} alt={alt} className={className} />;
};

export default Icon;
